// extracted by css-extract-rspack-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1_iA9","cls2":"PostEngagementFollowPrompt-cls2_5Td PostEngagementFollowPrompt-cls1_iA9"};